module.exports = __webpack_public_path__ + "static/media/clover-lose.85c9ac61.png";